import { SIDENAV_ACTION_TYPES } from '@constants/actionTypes/sideNavActionTypes';
import { configs } from '@constants/configs/configs';
import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import {
    getStoredEncHouseholdId,
    getStoredUserRefId,
    normalizeUserRefId,
    resolveSideNavReferenceId,
    setStoredEncHouseholdId,
    setStoredUserRefId,
    ENC_HOUSEHOLD_ID_SESSION_KEY,
    USER_REF_ID_SESSION_KEY,
} from './sideNavReferenceId';

const {
    endpoints: { GET_UNREAD_NOTIFICATION_COUNT },
} = configs;

export const setSideNavdetails = payload => ({
    type: SIDENAV_ACTION_TYPES.SET_SIDE_NAV_DETAILS,
    payload: payload,
});

export const setSideNavUnreadMessageCount = payload => ({
    type: SIDENAV_ACTION_TYPES.SET_SIDE_NAV_UNREAD_MESSAGE_COUNT,
    payload: payload,
});

export const setUserConfidentiality = (isConfidential: boolean) => ({
    type: SIDENAV_ACTION_TYPES.SET_USER_CONFIDENTIALITY,
    payload: isConfidential,
});

/**
 * Persists the reference id to sessionStorage and Redux (session is the fast path,
 * APIs the fallback). A blank/absent ref clears stored value to prevent leaking a
 * prior member's reference id after a member switch.
 */
export const syncSideNavReferenceId = (userRefId: string | null | undefined) => dispatch => {
    const normalizedRefId = normalizeUserRefId(userRefId);
    setStoredUserRefId(normalizedRefId);
    dispatch(setSideNavdetails({ referenceId: normalizedRefId }));
};

/**
 * Set-only: adds a household's ref, never clears. Only the SideNav container clears (on member switch).
 */
export const syncHouseholdReferenceId = household => dispatch => {
    const refId = normalizeUserRefId(household?.userRefId);
    if (refId) {
        dispatch(syncSideNavReferenceId(refId));
    }
};

export {
    getStoredEncHouseholdId,
    getStoredUserRefId,
    normalizeUserRefId,
    resolveSideNavReferenceId,
    setStoredEncHouseholdId,
    setStoredUserRefId,
    ENC_HOUSEHOLD_ID_SESSION_KEY,
    USER_REF_ID_SESSION_KEY,
};

const actions = { setError, startSpinner, stopSpinner };
export const fetchSideNavUnreadNotificationCount = (part, id) => async (dispatch, getState) => {
    const isEncrypted = isNaN(id);
    const endpoint = GET_UNREAD_NOTIFICATION_COUNT.processReplacements({ part, id, isEncrypted });
    const data = await API.getData(endpoint, dispatch, actions, false, getState());
    if (data && data.success) {
        dispatch(setSideNavUnreadMessageCount(data.payload));
        return Promise.resolve(data.payload);
    }
};